export function hide(el: Element | null): void {
  if (el instanceof HTMLElement) {
    el.style.display = 'none';
    el.style.transition = 'opacity 400ms';
  }
}

export function activate(el: Element | null) {
  if (el instanceof HTMLElement) {
    el.classList.add('active');
  }
}

export function fade(el: Element | null) {
  if (el instanceof HTMLElement) {
    el.classList.add('fade');
  }
}

export function close(el: Element | null) {
  if (el instanceof HTMLElement) {
    el.classList.remove('open');
  }
}

export function setTabIndex(el: Element | null) {
  if (el instanceof HTMLElement) {
    el.tabIndex = -1;
  }
}
